import store from '@/mutation/index'
import router from '../router';
// import router from '../router'
export function  stringIsNullOrEmpty(str, message){
    if(str == null || str == ''){
        throw  message
    }
}
export function  regCheck(reg,str, message){
    if (!reg.test(str)) {
        throw message;
    }
}

export  function getToken( obj){
    let tokenId = store.state.tokenId
    if(tokenId == ''){
        tokenId = localStorage.getItem(TOKEN_ID)
        if(tokenId == null ){
            router.replace({
                path: '/'
            })
            return ""
        }else{
            store.commit(TOKEN_ID,tokenId)
        }
    }
    obj.token = tokenId
}

export function convertDateFromString(dateString) { 
    // if (dateString) { 
    // var arr1 = dateString.split(" "); 
    // var sdate = arr1[0].split('-'); 
    // var date = new Date(sdate[0], sdate[1]-1, sdate[2]); 
    // return date;
    // } 
    return new Date(Date.parse(dateString)); 
}
export  function getEnableHight(){
    return   window.innerWidth
    || document.documentElement.clientWidth
    || document.body.clientWidth;
}

export  function utf8ByteArrayStrToStr( message){
    let strArray = message.split(";");
    let byteArray = []
    strArray.forEach(t=>{
      byteArray.push(parseInt(t))
    })
    let arr2 = new Uint8Array(byteArray) 
    let decoder = new TextDecoder('utf-8');
    let messageUtf8 = decoder.decode(arr2)
    return  messageUtf8;
}



// WEBPACK FOOTER //
// ./src/api/utils.js